import { render, staticRenderFns } from "./NormalPlay.vue?vue&type=template&id=88a61954&"
import script from "./NormalPlay.vue?vue&type=script&lang=js&"
export * from "./NormalPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports